
export default function Sort() {
  return (
    <div className="cs_shop_filter_wrap">
      <div className="cs_number_of_product">Showing 1–9 of 12 results</div>
      <form action="#" className="cs_shop_filter_form">
        <select>
          <option value="latest">Sort by latest</option>
          <option value="low">Sort by low price</option>
          <option value="high">Sort by high price</option>
        </select>
      </form>
    </div>
  )
}
